import { render, staticRenderFns } from "./StreakMobile.vue?vue&type=template&id=c642407e&scoped=true&"
import script from "./StreakMobile.vue?vue&type=script&lang=ts&"
export * from "./StreakMobile.vue?vue&type=script&lang=ts&"
import style0 from "./StreakMobile.vue?vue&type=style&index=0&id=c642407e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642407e",
  null
  
)

export default component.exports